import type { TextFieldData } from '@stratumn/studio-shared';

export const initialTextFieldData: TextFieldData = {
  title: 'Default Text Field Title',
  required: true,
  placeholder: ''
};
